<template>
  <q-checkbox
    v-bind="$attrs"
    v-model="modelValue"
    :disable="readOnlyComputed"
    :readonly="readOnlyComputed"
  >
    <slot />
  </q-checkbox>
</template>

<script setup lang="ts">
import { useReadOnly } from '@/composables/useReadOnly'

const modelValue = defineModel<boolean | (string | number)[] | string | number>()
const { isReadOnly: readOnlyComputed } = useReadOnly()
</script>
